import React from "react";
import { Link } from "react-router-dom";
import { NUM } from "@/components/ms";

interface AlertRowProps {
  title: string;
  datetime: string;
  seen?: boolean;
  value: string | null;
  imageUrl?: string;
  href?: string;
}

/** One row of the notifications list. A ruled figure row, not an alert form. */
const AlertRow: React.FC<AlertRowProps> = ({
  title,
  datetime,
  seen,
  value,
  imageUrl,
  href
}) => {
  return (
    <Link
      to={href || "#"}
      className="w-full border-b border-ms-line px-1 py-2 text-left transition-colors hover:bg-ms-chip"
    >
      <div className="flex flex-col justify-between">
        <div className="flex w-full items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            {imageUrl && (
              <img src={imageUrl} alt={title} className="h-6 w-6 rounded-full" />
            )}
            <span className="truncate text-[13px] font-semibold text-ms-ink">
              {title}
            </span>
          </div>
          <span className={`${NUM} flex-none text-[11px] text-ms-dim`}>{datetime}</span>
        </div>

        <span className="text-[12.5px] leading-[1.5] text-ms-mute">{value}</span>
      </div>
    </Link>
  );
};

export default AlertRow;
